// Library imports
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

// Internal component imports
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { AppLogo } from "@/components/shared/app-logo";
import { RegisterForm } from "../components/register-form";

const RegisterPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <main className="relative min-h-screen w-full flex flex-col items-center justify-center bg-gradient-to-b from-background to-background/95 px-4">
      {/* Logo */}
      <div className="mb-8">
        <AppLogo showText={false} />
      </div>

      {/* Register form */}
      <div className="w-full max-w-md">
        <Card className="bg-card/60 backdrop-blur-sm">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl">
              {t("auth.register.title")}
            </CardTitle>
            <CardDescription>
              {t("auth.register.description")}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <RegisterForm />
          </CardContent>
        </Card>
      </div>

      {/* Back to home link */}
      <div className="mt-6">
        <Link
          to="/"
          className="text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          {t("auth.login.backToHome")}
        </Link>
      </div>
    </main>
  );
};

export default RegisterPage;
